export const socialData = [
    {
        type: "github",
        color: "grey",
        link: "https://github.com/RETBOT",
    },
    {
        type: "linkedin",
        color: "linkedin",
        link: "https://www.linkedin.com/in/roberto-esquivel-troncoso/",
    },
    {
        type: "twitter",
        color: "twitter",
        link: "https://twitter.com/RobertoEsqTr",
    },
    {
        type: "facebook",
        color: "facebook",
        link: "https://www.facebook.com/robertoesquiveltroncoso",
    },
    {
        type: "instagram",
        color: "instagram",
        link: "https://www.instagram.com/robertoesquiveltroncoso/",
    },
]